export const languageChinese = {
    "formating": {
        "main": "主提示词",
        "jailbreak": "越狱提示词",
        "chats": "历史聊天",
        "lorebook": "世界书",
        "globalNote": "全局备注",
        "authorNote": "作者备注",
        "lastChat": "前一次聊天",
        "description": "角色描述",
        "personaPrompt": "用户提示词",
        "plain": "基础提示词",
        "memory": "Supa/HypaMemory",
        "postEverything": "系统提示词结束"
    },
    "errors": {
        "toomuchtoken": "错误：所需的 Token 数超过了可用的最大上下文大小",
        "unknownModel": "错误：无法识别所选的模型",
        "httpError": "错误：请求发生错误：",
        "noData": "这个文件好像不太对，或者数据已经损坏了。",
        "onlyOneChat": "至少需要一个聊天室",
        "alreadyCharInGroup": "该群组中已经有一个同名角色。",
        "noUserIcon": "请先设置你的个人头像。",
        "emptyText": "文字内容为空。",
        "wrongPassword": "密码错误",
        "networkFetch": "这通常是由于网络连接不稳定或服务器故障引起的。",
        "networkFetchWeb": "这可能是由 CORS 错误引起的。这种情况只会在使用网页版时发生，因为浏览器存在一些限制。请尝试使用本地版或其他版本的叡苏。",
        "networkFetchPlain": "这可能是一次数据抓取（Fetch）错误。请尝试在设置中关闭强制抓取选项。",
        "requestLogRemoved": "该请求记录已被删除。",
        "requestLogRemovedDesc": "当客户端刷新或加载时，该请求记录会被删除。",
        "vertexAuthError": "Vertex AI 身份验证详情缺失。",
        "coldStorageWriteFailed": "冷存储写入失败。您的聊天数据已被保留。",
        "coldStorageVerifyFailed": "冷存储验证失败。您的聊天数据已被保留。",
        "coldStorageRestoreFailed": "无法加载冷存储数据。受影响角色的数据可能已永久丢失。",
        "coldStorageIncompleteBackupConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `${characterNames || "未知角色"}的冷存储数据缺失或无效。${unresolvedCount > 0 ? `有 ${unresolvedCount} 个项目无法关联到角色。` : ""}\n\n如果继续，此备份将缺少 ${unavailableCount} 个冷存储项目，受影响的角色或聊天数据可能无法从该备份恢复。\n\n仍要创建不完整的备份吗？`,
        "coldStorageIncompleteRestoreConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `无法恢复 ${characterNames || "未知角色"}的冷存储数据。${unresolvedCount > 0 ? `有 ${unresolvedCount} 个项目无法关联到角色。` : ""}\n\n如果继续，${unavailableCount} 个冷存储项目将不可用，受影响的角色或聊天数据可能会永久丢失。\n\n仍要继续不完整的恢复吗？`
    },
    "showHelp": "显示帮助",
    "help": {
        "model": "此模型是指聊天中使用的主控模型。",
        "submodel": "辅助模型是一个用于分析情感图像、产生自动建议等的模型，推荐使用 GPT-3.5。",
        "oaiapikey": "OpenAI 的 API 密钥（Key），可在 https://platform.openai.com/account/api-keys 获取。",
        "mainprompt": "主提示词设置用于决定模型的默认行为。",
        "jailbreak": "当角色中的越狱开关被激活后，越狱提示词将被使用。",
        "globalNote": "一个对模型行为有强烈影响的备注（也称为 UJB），适用于所有角色。",
        "autoSuggest": "用于自动建议用户回应时生成选项的提示词。",
        "formatOrder": "提示词的排列顺序：越靠下的区块对模型的影响越大。",
        "forceUrl": "此字段不为空时，请求将被发送到你所输入的网址。",
        "tempature": "较低的数值会使角色更紧密地遵循提示词，但会使回应更制式与机械化。\n较高的数值则会增强角色的创意表现，但回应可能会变得不稳定。",
        "frequencyPenalty": "较高的数值可以避免角色在个别回应中重复使用相同的词汇，但回应也更容易出现语义混乱。",
        "presensePenalty": "较高的数值可以避免角色在整体对话中重复使用相同的词汇，但这也可能导致回答失去一致性和稳定性。",
        "sdProvider": "图像生成提供者。",
        "msgSound": "当角色回应时，播放 *叮* 的提示音",
        "charDesc": "角色的简要描述。这会影响角色的回应方式。",
        "charFirstMessage": "角色的初始消息，这会极大地影响角色的回应方式。",
        "charNote": "对模型行为有强烈影响的备注，嵌入到当前角色中，也称为 UJB。",
        "toggleNsfw": "切换越狱提示词的开关。",
        "lorebook": "世界书（Lorebook）是由用户创建的 AI 辞典，只有当上下文中包含关键词时 AI 才能看到它。",
        "loreName": "世界书的名称，不影响 AI。",
        "loreActivationKey": "当上下文中包含任一关键词时，该条目将被激活，并激活相应的提示词。使用逗号分隔。",
        "loreorder": "插入顺序越高，对模型的影响力越大。在激活大量条目时，也更不容易被截断。",
        "bias": "Bias 是一组键值数据，用于修改某些字符串出现的概率。\n其数值范围可以是 -100 到 100。较高的数值会使该字符串更可能出现，较低的数值则降低出现概率。\n另外，在某些模型中，若将数值设为 -101，该字符串将被标记为“强制禁止词”。\n警告：若 Tokenizer 设置有误，可能无法正常运作。",
        "emotion": "“表情立绘会根据角色情绪显示对应的图片。具体的情绪由角色的回应进行分析。你必须输入情绪名称作为词汇*（如：joy, happy, fear 等）*。若存在名为 **neutral** 的情绪，将作为默认情绪。至少需要三张图片才能正常运作。”",
        "imggen": "分析聊天内容后，将提示套用至 {{slot}}。",
        "regexScript": "正则表达式（Regex Script）是一个自定义工具，用于将符合条件的字符串由“IN”替换为“OUT”。\n\n有四种类型选项：\n\n- **修改输入（Modify Input）**：修改用户的输入内容\n\n- **修改输出（Modify Output）**：修改角色的输出内容\n\n- **修改请求数据（Modify Request Data）**：在当前聊天数据发送时进行修改\n\n- **修改显示（Modify Display）**：仅修改显示的文字，不更改聊天数据\n\n“IN”必须是一个不带标志（flags）的正则表达式，且开头和结尾不包含斜线。\n\n“OUT”是一个可以包含替换模式的字符串。这些替换模式如下：\n\n- $$\n\n  - 插入符号“$”\n\n- $&\n\n  - 插入匹配到的子字符串\n\n- $`\n\n  - 插入匹配子字符串前的部分\n\n- $1\n\n  - 插入第一个匹配群组，可以替换为其他数字（例如 2、3...）\n\n- $(name)\n\n  - 插入命名群组\n\n针对标志（flags），除了原生支持的标志之外，还可以使用下列专为高级用户设计的标志：\n\n- `<inject>`：将结果注入当前字符串中\n- `<move_top>`：将结果移到字符串的顶部\n- `<move_bottom>`：将结果移到字符串的底部\n- `<repeat_back>`：如果找不到匹配，则使用上一个匹配的结果\n- `<order n>`：设置结果的顺序，数值越高显示越靠前。“n”代表一个数字（例如 `<order 1>`）。如果未设置，默认为 0。\n- `<cbs>`：解析“IN”中的大括号语法\n\n若要与原生标志结合使用，可以像这样使用：`gi<cbs><move_top>`。",
        "experimental": "此为实验性功能，可能不稳定。",
        "oogaboogaURL": "如果你的 WebUI 支持旧版 API，你的 URL 应类似于 *https://.../run/textgen*。\n\n如果你的 WebUI 支持新版 API，你的 URL 应类似于 *https://.../api/v1/generate*，且将使用 API 服务器作为主机，并在参数中添加 —api。",
        "exampleMessage": "示范对话会影响角色的回应，但不会永久占用 Token。\n\n对话格式示例：\n\n```\n<START>\n{{user}}: hi\n{{char}}: hello\n<START>\n{{user}}: hi\nHaruhi: hello\n```\n\n```<START>``` 标记了一段新对话的开始。",
        "creatorQuotes": "说明将显示在初始消息之上，用于向用户提供角色说明。此内容不会进入提示词中。",
        "systemPrompt": "此字段不为空时，将替换设置中的主提示词为此内容。",
        "chatNote": "这是一个强烈影响模型行为的备注，嵌入于当前聊天中，也称为记忆或 UJB。",
        "personality": "对角色性格的简要描述。\n\n**不建议使用此字段，请填写在角色描述中。**",
        "scenario": "对角色情境的简要描述。\n\n**不建议使用此字段，请填写在角色描述中。**",
        "utilityBot": "激活后，将忽略主提示词、越狱提示词和其他提示词。适用于工具型机器人，而非用于角色扮演。",
        "loreSelective": "激活选择性模式后，需同时匹配关键词与次要关键詞，方可激活该条目。",
        "loreRandomActivation": "激活“使用概率条件”后，若同时符合激活条目的其他条件，则在每次发送聊天时，该条目将依照设置的概率被使用。",
        "additionalAssets": "在聊天中显示的额外资源。\n\n - 使用 `{{raw::<资源名称>}}` 作为路径。\n - 使用 `{{image::<资源名称>}}` 作为图片。\n - 使用 `{{video::<资源名称>}}` 作为影片。\n - 使用 `{{audio::<资源名称>}}` 作为音频。\n    - 建议放置在背景 HTML 中。",
        "superMemory": "SuperMemory 通过向 AI 提供摘要数据来增强角色的记忆能力。\n\nSuperMemory 是一个文本摘要功能，推荐使用 davinci 模型。不建议使用辅助模型，除非它是未经过滤、最大上下文长度超过 2000 Tokens，且具有良好摘要能力的模型。\n\nSuperMemory 提示词决定了模型如何撰写摘要。留空将使用默认提示词，建议保持留空。\n\n完成所有设置后，你可以在角色的设置中激活此功能。",
        "replaceGlobalNote": "此字段不为空时，将替换当前的全局备注为此内容。",
        "backgroundHTML": "将 Markdown/HTML 注入到聊天画面的背景中。\n\n你也可以使用额外资源。例如，你可以使用 {{audio::<资源名称}} 作为背景音乐。\n\n此外，你还可以与额外资源搭配使用以下格式：\n - {{bg::<资源名称>}}：将资源设为背景。",
        "additionalText": "只有当 AI 认为有必要时，才会将该段文本添加到角色描述中。你可以在此处放置较长的文本。使用双换行进内联容分隔。",
        "charjs": "这是一段会与角色一同运行的 JavaScript。详情请查看：https://github.com/kwaroran/RisuAI/blob/main/src/etc/example-char.js\n**出于安全原因，目前不建议使用。这些代码不会被包含在导出中。**",
        "romanizer": "Romanizer 是一个将非罗马字母转换为罗马字母的插件，用于减少请求数据时的 Token。这可能会导致输出结果与原始模型不同。如果已在聊天中使用罗马字母，不建议激活。",
        "inlayImages": "激活后，图片可嵌入聊天中，并且支持此功能的 AI 将能够看到它们。",
        "metrica": "Metric Systemizer 是一个插件，会在请求阶段将公制单位转换为英制单位，而在输出时转回公制，让用户在接口上显示公制单位，但性能上使用英制单位。如果在聊天中已经使用英制单位，不建议激活。",
        "lorePlus": "LoreBook+ 是一项实验性功能。使用向量数据库（VectorDB），而不仅是字符串匹配。目的在于提供更好的机器人创建体验和更好的匹配性能。",
        "topP": "Top P 是内核采样（Nucleus Sampling）的概率阈值，模型只会考虑总概率质量达到 top_p 的 Token 结果。",
        "openAIFixer": "OpenAI Fixer 是一个用于修复 OpenAI 部分问题的插件。",
        "sayNothing": "激活后，如果用户没有输入聊天内容，系统会自动填入 ’say nothing‘。",
        "showUnrecommended": "激活后，将显示不建议使用的过时设置。不建议使用这些设置。",
        "streamingDisplayOptimizationMode": "在使用正则脚本等大量后处理时，减少长回复流式生成造成的界面卡顿。对移动设备或低端设备可能有帮助。\n\n关闭会保留普通行为，但每个 Token 都会触发后处理，可能带来明显开销。\n\n均衡会只按较短间隔（约 0.125 秒）尝试后处理来降低负载。\n\n强与均衡类似，但流式生成期间会跳过后处理，只在流式完成后尝试一次后处理，从而大幅降低负载。\n\n这是一项实验性功能，可能会导致部分功能出现非预期行为。",
        "imageCompression": "激活后，在导出角色时会压缩略图片。如果动画图片无法显示，请尝试关闭此选项。",
        "useExperimental": "激活后，将显示部分实验性功能。",
        "forceProxyAsOpenAI": "激活后，使用反向代理（Reverse proxy）时将强制使用 OpenAI 格式。",
        "forcePlainFetch": "激活后，将使用浏览器的 Fetch API 来替代原生 HTTP 请求。这可能会导致 CORS 错误。",
        "autoFillRequestURL": "激活后，将自动填入请求 URL 以匹配当前模型。",
        "chainOfThought": "激活后，将在提示词中添加思维链（CoT）提示。",
        "gptVisionQuality": "此选项用于设置图像检测模型的质量。质量越高，检测越准确，但会使用更多的 Token。",
        "genTimes": "此设置支持模型上的重滚（reroll）回应数量。除第一则回应外，其他回应将作为缓存使用，以降低成本。但若未多次重滚回应，可能增加成本。",
        "requestretrys": "此选项用于设置请求失败时的重试次数。",
        "chatLoadInitialPages": "打开聊天界面时初始渲染的最近聊天消息数量。数值越高，能立即显示更多历史，但打开长聊天时可能更卡。",
        "chatLoadAdditionalPages": "每次向上滚动到顶部时额外渲染的旧聊天消息数量。数值越高，重复加载次数越少，但每次加载可能更重。",
        "emotionPrompt": "此选项用于设置情绪检测的提示词。留空将使用默认提示词。",
        "removePunctuationHypa": "激活后，将在执行 HypaMemory 前移除标点符号。",
        "additionalParams": "此选项允许将附加的参数添加到请求主体（Request body）中。若要排除某些参数，可以将值设为 `{{none}}`。若要添加包头（Request header）而非主体，可以在键前加上 `header::`，如 `header::Authorization`。若要将值作为 JSON，可以在值前加上 `json::`，如 `json::{\"key\":\"value\"}`。其他情况下，系统将自动判定值的类型。",
        "antiClaudeOverload": "若 Claude 过载发生，叡苏会透过继续相同的提示来阻止它，以减少过载的概率。此功能仅适用于串流回应（Streamed Responses），对非官方 API 端点可能无效。",
        "triggerScript": "触发器（Trigger）是一个自定义脚本，在符合条件时执行。可用于修改聊天数据、执行命令、更改变量等。类型取决于触发时的情况，也可由按钮触发，如 {{button::Display::TriggerName}} 或带有 risu-trigger=\"<TriggerName>\" 属性的 HTML 按钮。",
        "autoContinueChat": "激活后，当聊天不以标点符号结束时，系统将尝试继续对话。请勿在不使用标点符号的语言中激活此功能。",
        "combineTranslation": "激活后，将把被 HTML 标签分隔但属于同一句的文本合并后进行翻译，并在翻译结果上重新套用“修改显示”（Modify Display）。这有助于提高翻译的准确性。若激活此后接口出现异常，请关闭此选项并回报问题。",
        "dynamicAssets": "激活后，若在处理数据时找不到资源名称，系统将使用向量搜索（Vector Search）尝试查找最接近的资源名称并进行替换。",
        "dynamicAssetsEditDisplay": "激活后，动态资源将同样应用于“修改显示”阶段，但这可能会影响性能。",
        "nickname": "设置后，将在聊天中以此昵称取代角色名称，并显示于 {{char}} 和 <char>。",
        "useRegexLorebook": "激活后，世界书将改用正则表达式（Regex）搜索，而不再使用字符串匹配。格式为 /regex/flags。",
        "customChainOfThought": "警告：不再建议使用思维链（CoT）切换功能。请将相关提示词移至其他提示词字段。",
        "customPromptTemplateToggle": "可在此处设置自定义提示词切换功能。使用 `<toggle variable>=<toggle name>` 格式，每行一个，例如：`cot=Toggle COT`。你可以在提示词中透过 `{{getglobalvar::toggle_<toggle variable>}}` 语法来使用这些切换功能，如：`{{getglobalvar::toggle_cot}}`。",
        "defaultVariables": "可在此处设置自定义默认变量。使用 `<variable name>=<variable value>` 格式，每行一个。例如：`name=叡苏`，可在触发式和 CBS 变量中使用，如：`{{getvar::A}}`、`{{setvar::A::B}}` 或 `{{? $A + 1}}`。若提示词模板的默认变量与角色的默认变量名称相同，系统将使用角色的默认变量。",
        "lowLevelAccess": "激活后，将开放需要高计算能力的功能，并允许通过角色中的触发式执行 AI 模型。除非确实需要这些功能，否则不要激活此选项。",
        "triggerLLMPrompt": "这是将发送到模型的提示词。你可以使用 `@@role user`、`@@role system`、`@@role assistant` 来设置多轮对话及角色。例如：\n```\n@@role system\nrespond as hello\n@@role assistant\nhello\n@@role user\nhi\n```",
        "legacyTranslation": "激活后，将使用旧版翻译方法，在翻译前对 Markdown 和引号进行预处理，而非在翻译后处理。",
        "luaHelp": "可使用 Lua 作为触发式，并可定义 onInput、onOutput 和 onStart 函数。当用户发送消息时，调用 onInput；当角色发送消息时，调用 onOutput；当对话开始时，调用 onStart。详情请参阅说明文档。",
        "openAIFlexProcessing": "OpenAI Flex 响应可能比普通响应更慢，但可以用更低的价格（Batch API 价格）获得响应。此开关仅适用于官方 OpenAI Chat Completions 请求。",
        "claudeCachingExperimental": "Claude 缓存是实验性功能，可减少模型成本。但若在不使用重滚（reroll）回应的情况下激活，则可能增加成本。实验性功能可能不稳定，且未来可能会有所变动。",
        "urllora": "可使用模型文档的直接下载链接。通过类似 https://sites.google.com/site/gdocs2direct/ 的网站，从 Google Drive 等平台产生直接连接。或者使用 Civitai URL，复制 AIR（格式如 `urn:air:flux1:lora:civitai:180891@776656` 或 `civitai:180891@776656`），并粘贴。",
        "v2GetAlertSelect": "选项以 | (管道符号) 分隔。",
        "v2RegexTest": "若正则表达式匹配则返回 1，否则返回 0。",
        "v2Calculate": "计算数学表达式，支持基本算术 (+, -, *, /, %, ^)、比较运算符 (<, >, <=, >=, =, !=)、逻辑运算符 (&&, ||, !)、用于优先级的括号，以及使用 $variableName 格式的变量替换。变量会自动转换为数字（若无效则默认为 0）。",
        "namespace": "命名空间（Namespace）是模块的唯一标识符，用于防止模块冲突，并与默认和其他模块等进行交互。若不确定如何填写，建议留空。",
        "moduleIntergration": "可在模块集成区域中输入模块的命名空间（Namespace）来激活模块。若要激活多个模块，可用逗号分隔，例如：`module1,module2,module3`。此功能便于高级用户通过默认敏捷运用模块。",
        "customCSS": "自定义 CSS 样式。若出现问题，可使用 (Ctrl + .) 激活或禁用。",
        "betaMobileGUI": "激活后，将在小于 800px 的屏幕上使用测试版行动接口，需刷新页面。",
        "unrecommended": "这是一个不建议使用的设置。建议关闭。",
        "jsonSchema": "JSON Schema 将在 AI 模型支持时发送给模型。\n\n然而，由于 JSON Schema 学习难度较高，在叡苏中，你可以使用 TypeScript 接口的子集来代替 JSON Schema。叡苏将在运行时进行转换。例如，如果你想发送如下的JSON：\n\n```js\n{\n  \"name\": \"叡苏\", // name 必须是叡苏，\n  \"age\": 1, // age 必须是数字，\n  \"icon\": \"slim\", // icon 必须是 ’slim‘ 或 ’rounded‘\n  \"thoughts\": [\"Good View!\", \"Lorem\"] // thoughts 必须是字符串数组\n}\n```\n\n你可以使用以下 TypeScript 接口：\n\n```typescript\ninterface Schema {\n  name: string;\n  age: number;\n  icon: ’slim‘|’rounded‘\n  thoughts: string[]\n}\n```\n\n接口名称不重要。欲了解更多信息，请参阅 TypeScript 说明文档：https://www.typescriptlang.org/docs/handbook/interfaces.html 。要检查支持的 TypeScript 子集，请查看以下内容。<details><summary>支持的 TypeScript 子集</summary>\n\n支持的类型包括 `boolean`、`number`、`string` 和 `Array`。高级类型不被支持（如：单元类型、交集类型、联合类型、可选类型、字面量类型等），除了以下几种情况：\n\n        - 原始数据型别（Primitive Type）的数组（Array）：（如 `string[]`、`Array<boolean>`）\n        - 字符串之间的单值类型（Unit Types）：（例如 `’slim‘|’rounded‘`）\n\n        属性必须在同一内联定义。若一行中有多个属性，将会产生错误。属性和接口名称仅可使用拉丁字符，并在 ASCII 范围内。属性名称不得以单引号或双引号包裹。接口内部不支持嵌套。在定义属性的行中，不能包含 `{` 或 `}`。如果想使用更高级的类型，请使用 JSON Schema。\n        </details>",
        "strictJsonSchema": "激活后，某些模型将严格遵循提供的 JSON Schema。若禁用，可能会忽略 JSON Schema。",
        "extractJson": "此字段不为空时，将从回应中提取特定的 JSON 数据。例如：想从回应 `{\"response\": {\"text\": [\"hello\"]}}` 中提取 `response.text[0]`，可以填写 `response.text.0`。",
        "translatorNote": "可在此处为每个角色添加独特的翻译提示，但仅适用于使用 Ax. 模型进行翻译。要激活此功能，请在语言设置中包含 `{{slot::tnote}}`。此功能不适用群组聊天。",
        "groupInnerFormat": "用于定义群组聊天中非发言者角色的格式。此字段不为空时，将使用此格式替代默认格式。若 `Group Other Bot Role` 设置为 `assistant`，该格式也将应用于发言者。",
        "groupOtherBotRole": "用于定义群组聊天中非发言者的角色。",
        "chatHTML": "每个聊天插入的 HTML。\n\n可以使用CBS和特殊标签。\n- `<risutextbox>`：用于呈现文字的文本框\n- `<risuicon>`：用于显示用户或助理的头像\n- `<risubuttons>`：用于聊天编辑、翻译等图标按钮\n- `<risugeninfo>`：生成消息按钮。",
        "systemContentReplacement": "若模型不支持系统提示词，将使用此格式替换系统提示词。",
        "systemRoleReplacement": "若模型不支持系统角色，将使用此角色替换系统角色。",
        "summarizationPrompt": "用于摘要的提示词。留空将使用默认提示。你还可以使用带有 {{slot}} 的 ChatML 格式来处理聊天数据。",
        "translatorPrompt": "用于翻译的提示词。留空将使用默认提示。你还可以使用带有 {{slot}} 的 ChatML 格式表示目标语言：用 {{slot::content}} 表示内容，用 {{slot::tnote}} 表示翻译注释。",
        "translateBeforeHTMLFormatting": "激活后，将在正则脚本和 HTML 格式化之前翻译文本。这可能减少 Token 数，但可能破坏格式。",
        "autoTranslateCachedOnly": "如果在启用自动翻译的情况下启用，则仅会自动翻译用户之前已翻译过的消息。",
        "presetChain": "如果不为空，每次用户在此输入框预设列表中的消息时，预设将会更改并随机应用。预设列表应以逗号分隔，例如 `preset1,preset2`。",
        "legacyMediaFindings": "启用后，将使用旧方法查找媒体资源，而不使用额外的搜索算法。",
        "comfyWorkflow": "输入 Comfy UI 的 API 工作流。您可以通过点击“工作流 > 导出 (API)”按钮在 Comfy UI 中获取您的 API 工作流。您还必须在工作流文本中放入 {{risu_prompt}}。{{risu_prompt}} 将被替换为 Risu 提供的提示词。",
        "automaticCachePoint": "如果缓存点不存在，则在聊天结束后自动创建缓存点。",
        "experimentalChatCompressionDesc": "压缩未使用的聊天数据并保存到单独的文件中。这大大减少了聊天数据的大小，并大大提高了性能，但它是实验性的，可能不稳定，导致备份功能等出现问题。",
        "promptInfoInsideChatDesc": "启用后，这会将提示预设信息存储在聊天元数据中。存储的数据包括预设名称、活动切换和提示文本。这可能会略微增加处理时间和存储使用量。",
        "autoAdjustSchema": "启用后，将自动调整动态输出的 JSON 模式。",
        "dynamicMessages": "启用后，将允许助手连续发送多条消息，而不是一次发送一条。",
        "dynamicMemory": "启用后，助手将对响应时间进行记忆记录。需要额外的提示才能利用此功能。",
        "dynamicResponseTiming": "启用后，将动态调整响应时间。",
        "dynamicRequest": "启用后，将在随机时间请求模型，而无需等待用户输入。",
        "settingsCloseButtonSize": "调整设置窗口右上角关闭(X)按钮的大小。默认值为24。",
        "showTypingEffect": "启用后，将在助手生成响应时显示打字指示器。",
        "dynamicOutputPrompt": "启用后，架构信息将包含在请求中。",
        "realmDirectOpen": "启用后，点击 RisuRealm 预览中的角色将直接打开角色描述。",
        "openRouterProviderOrder": "使用提供商的顺序，将优先使用第一个提供商，若该提供商不可用，则会使用下一个提供商。详见 https://openrouter.ai/docs/guides/routing/provider-selection#ordering-specific-providers",
        "openRouterProviderOnly": "仅使用此列表中的提供商，若所有提供商都不可用，请求将会失败。详见 https://openrouter.ai/docs/guides/routing/provider-selection#allowing-only-specific-providers",
        "openRouterProviderIgnore": "忽略此列表中的提供商，若所有提供商都被忽略，请求将会失败。详见 https://openrouter.ai/docs/guides/routing/provider-selection#ignoring-providers",
        "additionalPrompt": "启用提示词预处理时，这段文本会添加到主提示词的末尾。默认值是 'The assistant must act as {{char}}. user is {{user}}.'，用于设置基本的角色扮演背景。",
        "hideAllImagesDesc": "隐藏机器人图标、机器人图片资源和RisuRealm封面图片。",
        "embedding": "嵌入模型用于多个功能中的相似度搜索：\n\n- **长期记忆**: HypaV2, HypaV3, Hanurai Memory 和 SupaMemory (启用 HypaMemory 时)\n- **附加文本**: 基于上下文匹配角色附加信息\n- **动态资产**: 当未找到精确匹配时查找相似的资产名称\n- **情感图片**: 当情感方式设置为 'embedding' 时\n- **触发脚本**: 触发脚本中的相似度条件\n- **文件附件**: 在 PDF/TXT/XML 附件中搜索\n- **Playground**: Playground 中的嵌入测试",
        "enableScrollToActiveChar": "如果启用，在拖动角色时按下热键或按住 Ctrl 键将滚动到当前活跃的角色。如果文件夹已关闭，将自动打开。"
    },
    "setup": {
        "chooseProvider": "选择 AI 提供者",
        "openaikey": "使用 OpenAI API 密钥（推荐）",
        "openaiProxy": "OpenAI 反向代理",
        "setupmodelself": "其他／自行设置",
        "inputApiKey": "请在此输入 API 密钥",
        "apiKeyhelp": "可在以下获取 API 密钥：",
        "setupSelfHelp": "欢迎画面结束后，可前往设置中自行配置。",
        "theme": "选择介面主题",
        "themeDescWifulike": "不适合在行动设备上使用",
        "themeDescWifuCut": "适合在行动设备上使用",
        "themeDescClassic": "适用于所有设备",
        "texttheme": "设置文字颜色",
        "inputName": "最后，请输入你的昵称。",
        "welcome": "欢迎使用 Risu（叡苏）！我将引导你进行设置。请问我该如何称呼你？",
        "welcome2": "你好，{username}！在开始之前，我会问你一些问题，稍后可在设置中进行修改。\n\n首先，请选择 AI 提供者。",
        "openRouterProvider": "OpenRouter 提供许多模型，部分免费且未经内容过滤，但质量不如 OpenAI。",
        "hordeProvider": "Horde 提供免费服务，但回应时间较长且质量较低。",
        "setProviderLater": "还有其他提供者，你可以稍后在设置中配置。如想稍后设置，请选择此选项。",
        "setupOpenAI": "使用 OpenAI 需要获取 API 密钥（Key）。\n1. 前往 https://beta.openai.com/ \n2. 使用账号登录 \n3. 前往 https://beta.openai.com/account/api-keys \n4. 点击“Create New API Key”，并命名密钥。 \n5. 复制该密钥。 \n6. 返回叡苏\n7. 粘贴密钥并点击“发送”。",
        "setupClaude": "使用 Claude，你需要获取一个 API 密钥。",
        "setupClaudeSteps": [
            "访问此链接并使用 Google 帐户登录",
            "输入您的信息并点击“继续”（Continue）",
            "在组织页面，仅在第一个框中输入任意名称，然后点击“创建账户”",
            "点击“购买积分”（Buy Credits）",
            "点击“完成设置”（Complete Setup）",
            "输入如上图所示的内容，但国家／地区部分需自行输入。完成后点击“继续”（Continue）",
            "添加您的支付方式并点击“继续”（Continue）",
            "支付完成后，点击“添加资金”（Add Funds），最低需添加 5 美元或设置自动充值",
            "添加金额后，转到仪表板页面并点击“获取 API 密钥”（Get API Keys）",
            "点击“创建 API 密钥”（Create API Key）",
            "按照上图输入信息，然后点击“添加”（Add）",
            "複製密钥，将其粘贴在此并发送。"
        ],
        "setupOpenRouter": "使用 OpenRouter 需要获取 API 密钥（Key）。 \n1. 前往 https://openrouter.ai/keys\n2. 点击“Create Key”\n3. 任意命名密钥名称。\n4. 复制该密钥。\n5. 返回叡苏\n6. 粘贴密钥并点击“发送”。",
        "allDone": "完成所有设置！请稍待片刻。",
        "setupLaterMessage": "欢迎，{username}！你希望我引导你完成设置还是自行设置？",
        "setupMessageOption1": "引导我完成设置",
        "setupMessageOption1Desc": "推荐新用户使用",
        "setupMessageOption2": "由我自己完成设置",
        "claudeDesc": "Claude 是由 Antropic 开发的 AI 模型，是 OpenAI 的竞争对手。如果你希望使用非英语语言，它优于 GPT。",
        "openAIDesc": "OpenAI GPT 是高质量的 AI 模型，但它付费且存在内容过滤，在非英语环境下表现较弱。",
        "chooseChatType": "很好！现在请选择聊天语言。",
        "chooseChatTypeOption1": "全英语",
        "chooseChatTypeOption1Desc": "推荐英语使用者。AI 将使用英语进行输入和输出。",
        "chooseChatTypeOption2": "英语处理",
        "chooseChatTypeOption2Desc": "推荐非英语使用者。AI 内部使用英语处理，但输入输出为您的语言。",
        "chooseChatTypeOption3": "无语言侧重",
        "chooseChatTypeOption3Desc": "AI 将使用你的语言处理，但可能会降低回应质量。",
        "chooseCheapOrMemory": "除此之外，你更倾向于记忆功能还是节约成本？",
        "chooseCheapOrMemoryOption1": "记忆功能",
        "chooseCheapOrMemoryOption1Desc": "AI 会记住更多内容，但费用较高。",
        "chooseCheapOrMemoryOption2": "省钱模式",
        "chooseCheapOrMemoryOption2Desc": "AI 会记住较少内容，但费用更低。",
        "chooseCheapOrMemoryOption3": "平衡",
        "chooseCheapOrMemoryOption3Desc": "AI 记住的内容多于省钱模式，但不及使用记忆功能。",
        "chooseCheapOrMemoryOption4": "无限制",
        "chooseCheapOrMemoryOption4Desc": "AI 会记住几乎所有内容，但费用极高。",
        "finally": "最后，你是否希望使用进阶工具？",
        "finallyOption1": "是",
        "finallyOption1Desc": "使用进阶工具会使界面变得更複杂。推荐高级用户使用。",
        "finallyOption2": "否",
        "finallyOption2Desc": "不使用高级工具将使界面更简洁。推荐新使用者使用。",
        "igpPrompt": "若 IGP 提示词不为空，它将在主模型请求之后，作为情感模型执行，并将结果添加到主模型回应之后。"
    },
    "triggerCategories": {
        "Special": "特殊",
        "Control": "控制",
        "Chat": "聊天",
        "Low Level": "低级",
        "Alert": "警告",
        "Lorebook V2": "世界书 V2",
        "String": "字符串",
        "Data": "数据",
        "Array": "数组",
        "Others": "其他",
        "Deprecated": "已弃用"
    },
    "triggerDesc": {
        "v2Header": "标头",
        "v2HeaderDesc": "标头",
        "v2If": "如果",
        "v2IfDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2Else": "否则",
        "v2ElseDesc": "否则",
        "v2EndIndent": "结束缩进",
        "v2EndIndentDesc": "结束缩进",
        "v2SetVar": "设置变量",
        "v2SetVarDesc": "设置变量 {{var}} {{operator}} {{value}}",
        "v2Loop": "无限循环",
        "v2LoopDesc": "无限循环",
        "v2BreakLoop": "中断循环",
        "v2BreakLoopDesc": "中断循环",
        "v2RunTrigger": "运行触发器",
        "v2RunTriggerDesc": "运行触发器 {{target}}",
        "v2ConsoleLog": "控制台日志",
        "v2ConsoleLogDesc": "控制台日志 {{source}}",
        "v2StopTrigger": "停止触发器",
        "v2StopTriggerDesc": "停止触发器",
        "v2CutChat": "剪切聊天",
        "v2CutChatDesc": "剪切聊天从 {{start}} 到 {{end}}",
        "v2ModifyChat": "修改聊天",
        "v2ModifyChatDesc": "修改索引为 {{index}} 的聊天内容为 {{value}}",
        "v2SystemPrompt": "添加系统提示词",
        "v2SystemPromptDesc": "在 {{location}} 添加系统提示词 {{value}}",
        "v2Impersonate": "发送聊天",
        "v2ImpersonateDesc": "以 {{role}} 身份发送内容 {{value}}",
        "v2Command": "运行命令",
        "v2CommandDesc": "运行命令 {{value}}",
        "v2SendAIprompt": "发送 AI 提示词",
        "v2SendAIpromptDesc": "发送 AI 提示词",
        "v2ImgGen": "图像生成",
        "v2ImgGenDesc": "从 {{value}} 生成图像，负面提示词 {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "检查相似度",
        "v2CheckSimilarityDesc": "检查 {{source}} 和 {{value}} 之间的相似度 => {{outputVar}}",
        "v2RunLLM": "运行模型",
        "v2RunLLMDesc": "向模型发送请求 {{value}} => {{outputVar}}",
        "v2ShowAlert": "显示警告",
        "v2ShowAlertDesc": "显示警告 {{value}}",
        "v2ExtractRegex": "提取正则",
        "v2ExtractRegexDesc": "使用正则 {{regexType}} {{regex}} 和标志 {{flagsType}} {{flags}} 从 {{value}} 中提取文本，并将结果存储为 {{resultType}} {{result}} => {{outputVar}}",
        "v2RegexTest": "正则测试",
        "v2RegexTestDesc": "测试 {{value}} 是否匹配正则 {{regex}} 和标志 {{flags}} => {{outputVar}}",
        "v2GetLastMessage": "获取最后一条消息",
        "v2GetLastMessageDesc": "获取最后一条消息 => {{outputVar}}",
        "v2GetMessageAtIndex": "获取指定索引的消息",
        "v2GetMessageAtIndexDesc": "获取索引为 {{index}} 的消息 => {{outputVar}}",
        "v2GetMessageCount": "获取消息数量",
        "v2GetMessageCountDesc": "获取消息数量 => {{outputVar}}",
        "v2GetLorebook": "获取世界书",
        "v2GetLorebookDesc": "获取名为 {{target}} 的世界书 => {{outputVar}}",
        "v2GetLorebookCount": "获取世界书数量",
        "v2GetLorebookCountDesc": "获取世界书数量 => {{outputVar}}",
        "v2GetLorebookEntry": "获取指定索引的世界书条目",
        "v2GetLorebookEntryDesc": "获取索引为 {{index}} 的世界书条目 => {{outputVar}}",
        "v2SetLorebookActivation": "设置世界书激活状态",
        "v2SetLorebookActivationDesc": "设置索引为 {{index}} 的世界书激活状态为 {{value}}",
        "v2GetLorebookIndexViaName": "通过名称获取世界书索引",
        "v2GetLorebookIndexViaNameDesc": "通过名称 {{name}} 获取世界书索引 => {{outputVar}}",
        "v2ModifyLorebook": "修改世界书",
        "v2ModifyLorebookDesc": "修改名为 {{target}} 的世界书内容为 {{value}}",
        "v2LoopNTimes": "循环 N 次",
        "v2LoopNTimesDesc": "循环 {{value}} 次",
        "v2Random": "随机数",
        "v2RandomDesc": "生成从 {{min}} 到 {{max}} 的随机数 => {{outputVar}}",
        "v2GetCharAt": "获取指定索引的字符",
        "v2GetCharAtDesc": "从 {{source}} 获取索引为 {{index}} 的字符 => {{outputVar}}",
        "v2GetCharCount": "获取字符数量",
        "v2GetCharCountDesc": "从 {{source}} 获取字符数量 => {{outputVar}}",
        "v2ToLowerCase": "转换为小写",
        "v2ToLowerCaseDesc": "将 {{source}} 转换为小写 => {{outputVar}}",
        "v2ToUpperCase": "转换为大写",
        "v2ToUpperCaseDesc": "将 {{source}} 转换为大写 => {{outputVar}}",
        "v2SetCharAt": "设置指定索引的字符",
        "v2SetCharAtDesc": "将 {{source}} 中索引为 {{index}} 的字符设置为 {{value}} => {{outputVar}}",
        "v2SplitString": "分割字符串",
        "v2SplitStringDesc": "使用 {{delimiter}} 分割 {{source}} => {{outputVar}}",
        "v2GetCharacterDesc": "获取角色描述",
        "v2GetCharacterDescDesc": "获取角色描述 => {{outputVar}}",
        "v2SetCharacterDesc": "设置角色描述",
        "v2SetCharacterDescDesc": "将角色描述设置为 {{value}}",
        "v2GetPersonaDesc": "获取用户描述",
        "v2GetPersonaDescDesc": "获取用户描述 => {{outputVar}}",
        "v2SetPersonaDesc": "设置用户描述",
        "v2SetPersonaDescDesc": "将用户描述设置为 {{value}}",
        "v2GetReplaceGlobalNote": "获取替换全局备注",
        "v2GetReplaceGlobalNoteDesc": "获取替换全局备注 => {{outputVar}}",
        "v2SetReplaceGlobalNote": "设置替换全局备注",
        "v2SetReplaceGlobalNoteDesc": "将替换全局备注设置为 {{value}}",
        "v2GetAuthorNote": "获取作者备注",
        "v2GetAuthorNoteDesc": "获取作者备注 => {{outputVar}}",
        "v2SetAuthorNote": "设置作者备注",
        "v2SetAuthorNoteDesc": "将作者备注设置为 {{value}}",
        "v2Comment": "添加注释",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "声明局部变量",
        "v2DeclareLocalVarDesc": "声明局部变量 {{var}} 并赋值为 {{value}}",
        "v2MakeArrayVar": "创建数组变量",
        "v2MakeArrayVarDesc": "创建数组变量 {{var}}",
        "v2GetArrayVarLength": "获取数组变量长度",
        "v2GetArrayVarLengthDesc": "获取数组变量 {{var}} 的长度 => {{outputVar}}",
        "v2GetArrayVar": "获取数组变量元素",
        "v2GetArrayVarDesc": "获取数组变量 {{var}} 中索引为 {{index}} 的元素 => {{outputVar}}",
        "v2SetArrayVar": "设置数组变量元素",
        "v2SetArrayVarDesc": "将数组变量 {{var}} 中索引为 {{index}} 的元素设置为 {{value}}",
        "v2PushArrayVar": "添加到数组变量",
        "v2PushArrayVarDesc": "将 {{value}} 添加到数组变量 {{var}}",
        "v2PopArrayVar": "移除并获取数组变量最后一个元素",
        "v2PopArrayVarDesc": "移除数组变量 {{var}} 的最后一个元素 => {{outputVar}}",
        "v2ShiftArrayVar": "移除并获取数组变量第一个元素",
        "v2ShiftArrayVarDesc": "移除数组变量 {{var}} 的第一个元素 => {{outputVar}}",
        "v2UnshiftArrayVar": "添加到数组变量开头",
        "v2UnshiftArrayVarDesc": "将 {{value}} 添加到数组变量 {{var}} 的开头",
        "v2SpliceArrayVar": "在指定索引处添加到数组变量",
        "v2SpliceArrayVarDesc": "将 {{value}} 添加到数组变量 {{var}} 的 {{start}} 处",
        "v2SliceArrayVar": "截取数组变量",
        "v2SliceArrayVarDesc": "截取数组变量 {{var}} 从 {{start}} 到 {{end}} => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "获取值在数组变量中的索引",
        "v2GetIndexOfValueInArrayVarDesc": "获取 {{value}} 在数组变量 {{var}} 中的索引 => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "从数组变量中移除索引",
        "v2RemoveIndexFromArrayVarDesc": "从数组变量 {{var}} 中移除索引为 {{index}} 的元素",
        "v2JoinArrayVar": "连接数组",
        "v2JoinArrayVarDesc": "使用 {{delimiter}} 连接数组 {{var}} => {{outputVar}}",
        "v2MakeDictVar": "创建字典变量",
        "v2MakeDictVarDesc": "创建字典变量 {{var}}",
        "v2GetDictVar": "获取字典值",
        "v2GetDictVarDesc": "从字典 {{var}} 中获取键为 {{key}} 的值 => {{outputVar}}",
        "v2SetDictVar": "设置字典值",
        "v2SetDictVarDesc": "将字典 {{var}} 中键为 {{key}} 的值设置为 {{value}}",
        "v2DeleteDictKey": "删除字典键",
        "v2DeleteDictKeyDesc": "从字典 {{var}} 中删除键 {{key}}",
        "v2HasDictKey": "检查字典键是否存在",
        "v2HasDictKeyDesc": "检查字典 {{var}} 是否存在键 {{key}} => {{outputVar}}",
        "v2ClearDict": "清空字典",
        "v2ClearDictDesc": "清空字典 {{var}}",
        "v2GetDictSize": "获取字典大小",
        "v2GetDictSizeDesc": "获取字典 {{var}} 的大小 => {{outputVar}}",
        "v2GetDictKeys": "获取字典所有键",
        "v2GetDictKeysDesc": "获取字典 {{var}} 的所有键 => {{outputVar}}",
        "v2GetDictValues": "获取字典所有值",
        "v2GetDictValuesDesc": "获取字典 {{var}} 的所有值 => {{outputVar}}",
        "v2ConcatString": "连接字符串",
        "v2ConcatStringDesc": "连接 {{source1}} 和 {{source2}} => {{outputVar}}",
        "v2GetLastUserMessage": "获取最后一条用户消息",
        "v2GetLastUserMessageDesc": "获取最后一条用户消息 => {{outputVar}}",
        "v2GetLastCharMessage": "获取最后一条角色消息",
        "v2GetLastCharMessageDesc": "获取最后一条角色消息 => {{outputVar}}",
        "v2GetFirstMessage": "获取第一条消息",
        "v2GetFirstMessageDesc": "获取第一条消息 => {{outputVar}}",
        "v2GetAlertInput": "获取弹窗输入",
        "v2GetAlertInputDesc": "获取弹窗输入 => {{outputVar}}",
        "v2GetAlertSelect": "获取弹窗选择",
        "v2GetAlertSelectDesc": "获取弹窗选择 {{display}} 选项 {{value}} => {{outputVar}}",
        "v2UnsupportedTrigger": "不支持的触发器",
        "v2UnsupportedTriggerDesc": "不支持的触发器",
        "v2GetDisplayState": "获取显示状态",
        "v2GetDisplayStateDesc": "获取显示状态 => {{outputVar}}",
        "v2SetDisplayState": "设置显示状态",
        "v2SetDisplayStateDesc": "将显示状态设置为 {{value}}",
        "v2UpdateGUI": "更新界面",
        "v2UpdateGUIDesc": "更新界面",
        "v2UpdateChatAt": "更新指定索引的聊天",
        "v2UpdateChatAtDesc": "重绘索引为 {{index}} 的聊天",
        "v2Wait": "等待",
        "v2WaitDesc": "等待 {{value}} 秒",
        "v2GetRequestState": "获取请求数据内容",
        "v2GetRequestStateDesc": "获取索引为 {{index}} 的请求内容 => {{outputVar}}",
        "v2SetRequestState": "设置请求数据内容",
        "v2SetRequestStateDesc": "将索引为 {{index}} 的请求内容设置为 {{value}}",
        "v2GetRequestStateRole": "获取请求数据角色",
        "v2GetRequestStateRoleDesc": "获取索引为 {{index}} 的请求数据角色 => {{outputVar}}",
        "v2SetRequestStateRole": "设置请求数据角色",
        "v2SetRequestStateRoleDesc": "将索引为 {{index}} 的请求数据角色设置为 {{value}}",
        "v2GetRequestStateLength": "获取请求数据长度",
        "v2GetRequestStateLengthDesc": "获取请求数据长度 => {{outputVar}}",
        "v2IfAdvanced": "如果",
        "v2IfAdvancedDesc": "如果 {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "快速搜索聊天",
        "v2QuickSearchChatDesc": "在 {{depth}} 深度内，以 {{condition}} 条件在聊天中快速搜索 {{value}} => {{outputVar}}",
        "v2StopPromptSending": "停止发送提示词",
        "v2StopPromptSendingDesc": "停止发送提示词",
        "v2Tokenize": "Tokenize",
        "v2TokenizeDesc": "Tokenize {{value}} => {{outputVar}}",
        "v2GetAllLorebooks": "获取所有世界书",
        "v2GetAllLorebooksDesc": "获取所有世界书提示词数组 => {{outputVar}}",
        "v2GetLorebookByName": "按名称获取世界书索引",
        "v2GetLorebookByNameDesc": "按名称 {{name}} 获取世界书索引数组 => {{outputVar}}",
        "v2GetLorebookByIndex": "获取世界书",
        "v2GetLorebookByIndexDesc": "获取索引为 {{index}} 的世界书提示词 => {{outputVar}}",
        "v2CreateLorebook": "创建世界书",
        "v2CreateLorebookDesc": "创建名称为 {{name}}，键为 {{key}}，内容为 {{content}} 的世界书",
        "v2ModifyLorebookByIndex": "修改世界书",
        "v2ModifyLorebookByIndexDesc": "修改索引为 {{index}} 的世界书，名称为 {{name}}，键为 {{key}}，内容为 {{content}}",
        "v2DeleteLorebookByIndex": "删除世界书",
        "v2DeleteLorebookByIndexDesc": "删除索引为 {{index}} 的世界书",
        "v2GetLorebookCountNew": "获取世界书数量",
        "v2GetLorebookCountNewDesc": "获取世界书总数 => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "设置世界书始终激活",
        "v2SetLorebookAlwaysActiveDesc": "将索引为 {{index}} 的世界书始终激活设置为 {{value}}",
        "v2Calculate": "计算",
        "v2CalculateDesc": "计算 {{expression}} => {{outputVar}}",
        "v2ReplaceString": "替换字符串",
        "v2ReplaceStringDesc": "使用正则 {{regex}} 将 {{source}} 替换为 {{replacement}} => {{outputVar}}"
    },
    "triggerInputLabels": {
        "value": "值",
        "var": "变量",
        "varName": "变量名",
        "outputVar": "输出变量",
        "name": "名称",
        "index": "索引",
        "source": "来源",
        "target": "目标",
        "condition": "条件",
        "operator": "操作符",
        "role": "角色",
        "location": "位置",
        "prompt": "提示词",
        "model": "模型",
        "start": "开始",
        "end": "结束",
        "min": "最小值",
        "max": "最大值",
        "delimiter": "分隔符",
        "depth": "深度",
        "key": "键",
        "alertContent": "警告内容",
        "options": "选项",
        "cmd": "命令",
        "regex": "正则表达式",
        "replacement": "替换内容",
        "flags": "标志",
        "negPrompt": "负面提示词",
        "resultFormat": "结果格式",
        "activationKeys": "激活键",
        "insertOrder": "插入顺序",
        "sysStart": "系统开始",
        "sysHistoryEnd": "系统历史结束",
        "sysPromptEnd": "系统提示结束",
        "addElse": "添加否则",
        "alwaysActive": "始终激活",
        "trigger": "触发器",
        "triggerOn": "触发于",
        "valueTypeDesc": "直接使用输入值",
        "varTypeDesc": "使用存储在变量中的值",
        "conditionEqual": "等于 (=)",
        "conditionNotEqual": "不等于 (≠)",
        "conditionGreater": "大于 (>)",
        "conditionLess": "小于 (<)",
        "conditionGreaterEqual": "大于等于 (≥)",
        "conditionLessEqual": "小于等于 (≤)",
        "conditionSimilar": "相似 (≒)",
        "conditionContains": "包含 (∋)",
        "conditionIn": "在...中 (∈)",
        "conditionNotContains": "不包含 (∌)",
        "conditionNotIn": "不在...中 (∉)",
        "conditionTruthy": "真值 (≡)",
        "operatorSet": "赋值 (=)",
        "operatorAdd": "加 (+=)",
        "operatorSubtract": "减 (-=)",
        "operatorMultiply": "乘 (*=)",
        "operatorDivide": "除 (/=)",
        "operatorModulo": "取模 (%=)",
        "searchLoose": "宽松搜索",
        "searchStrict": "严格搜索",
        "searchRegex": "正则搜索",
        "modelMain": "主模型",
        "modelSub": "辅助模型",
        "roleUser": "用户",
        "roleChar": "角色",
        "roleSystem": "系统",
        "roleAssistant": "助手",
        "boolTrue": "True",
        "boolFalse": "False",
        "boolNull": "Null",
        "helpVarName": "输入变量名称",
        "helpOutputVar": "输入用于存储结果的变量名称",
        "helpIndex": "数组或消息索引号",
        "helpRegex": "输入正则模式",
        "helpFlags": "正则标志",
        "helpDelimiter": "用于分割字符串的分隔符",
        "helpActivationKeys": "逗号分隔的激活关键词",
        "helpInsertOrder": "插入顺序",
        "helpDepth": "搜索消息的深度",
        "helpMinMax": "最小值和最大值范围",
        "helpSlot": "使用 {{slot}} 保持不变",
        "expression": "表达式"
    },
    "playground": {
        "playground": "Playground",
        "inlayDeleteConfirm": "确定要删除\"{name}\"吗？",
        "inlayDeleteMultipleConfirm": "确定要删除选中的{count}个资源吗？",
        "inlayDeleteSelected": "删除选中项",
        "inlayDeselectAll": "取消全选",
        "inlayEmpty": "没有保存的内联资源",
        "inlayEmptyDesc": "在聊天中附加或生成的图像、音频和视频将显示在这里",
        "inlayExplorer": "内联资源浏览器",
        "inlaySelectAll": "全选",
        "inlayTotalAssets": "共{count}个资源",
    },
    "confirm": "确定",
    "goback": "返回",
    "botSettings": "机器人设置",
    "model": "模型",
    "apiKey": "API 密钥",
    "providerURL": "请求地址（URL）",
    "providerJSON": "请求主体（JSON）",
    "mainPrompt": "主提示词",
    "jailbreakPrompt": "越狱提示词",
    "globalNote": "全局备注",
    "autoSuggest": "自动建议",
    "tokens": "Tokens",
    "maxContextSize": "最大上下文长度（Max Context Size）",
    "maxResponseSize": "最大回应长度（Max Response Size）",
    "temperature": "温度（Temperature）",
    "frequencyPenalty": "频率惩罚（Frequency Penalty）",
    "presensePenalty": "存在惩罚（Presence Penalty）",
    "advancedSettings": "高级设置",
    "advancedSettingsWarn": "警告：若不确定该选项的作用，请勿进行修改！",
    "formatingOrder": "格式顺序",
    "authorNote": "作者备注",
    "firstMessage": "初始消息",
    "description": "描述",
    "note": "说明",
    "jailbreakToggle": "使用越狱提示词",
    "charIcon": "角色头像",
    "characterDisplay": "角色演示",
    "viewScreen": "额外角色画面",
    "none": "无",
    "emotionImage": "表情立绘",
    "noImages": "没有图片",
    "noBias": "No Bias",
    "image": "图片",
    "name": "名称",
    "folderName": "文件夹名称",
    "folderRemoveConfirm": "此文件夹包含世界书。确定要删除它及其所有内容吗？",
    "emotion": "情绪名称",
    "value": "值",
    "reroll": "重新生成",
    "chatList": "聊天列表",
    "removeChat": "确定要移除此消息吗？",
    "loreBook": "世界书",
    "character": "角色",
    "Chat": "聊天",
    "globalLoreInfo": "角色世界书适用于该角色的所有对话。",
    "group": "群组",
    "groupLoreInfo": "群组世界书适用于该群组的所有对话。",
    "localLoreInfo": "聊天世界书仅用于此对话。",
    "removeConfirm": "你确定要删除：",
    "removeConfirm2": "你**真的**确定要删除：",
    "exportConfirm": "你想要导出此数据吗？",
    "insertOrder": "插入顺序",
    "activationKeys": "关键词",
    "activationKeysInfo": "使用逗号分隔",
    "prompt": "提示词",
    "loreBookDepth": "世界书搜索深度",
    "loreBookToken": "世界书最大 Token 数",
    "chatLoadInitialPages": "聊天初始加载数量",
    "chatLoadAdditionalPages": "聊天追加加载数量",
    "removeCharacter": "删除角色",
    "removeGroup": "删除群组",
    "exportCharacter": "导出角色",
    "userSetting": "用户设置",
    "username": "你的名称",
    "userIcon": "你的头像",
    "successExport": "已成功导出并保存至你的下载数据夹",
    "successImport": "成功导入",
    "importedCharacter": "导入角色",
    "alwaysActive": "始终激活",
    "additionalPrompt": "附加提示词",
    "descriptionPrefix": "描述前缀",
    "forceReplaceUrl": "反向代理",
    "emotionWarn": "正在使用辅助模型。",
    "plugin": "插件",
    "language": "语言",
    "UiLanguage": "介面语言",
    "createfromScratch": "自行创建",
    "importCharacter": "导入角色",
    "translator": "翻译器",
    "disabled": "关闭",
    "noPluginSelected": "已选择模型为插件，但未选择插件。",
    "text": "文字",
    "UISize": "聊天文字大小",
    "newVersion": "发现更新，是否进行安装？",
    "remindLaterQuestion": "什么时候再提醒您？",
    "remindIgnore": "忽略",
    "remindLater1Day": "1天后提醒",
    "remindLater3Days": "3天后提醒",
    "remindLater5Days": "5天后提醒",
    "remindLater1Week": "1周后提醒",
    "display": "显示 & 音频",
    "useCustomBackground": "自定义背景",
    "translateInput": "翻译输入",
    "autoTranslation": "自动翻译",
    "fullscreen": "全屏幕",
    "playMessage": "播放消息音效",
    "iconSize": "头像大小",
    "createGroup": "创建群组",
    "groupIcon": "群组头像",
    "single": "单个",
    "multiple": "多个",
    "useCharLorebook": "使用角色世界书",
    "selectChar": "选择角色",
    "askLoadFirstMsg": "是否加载初始消息？",
    "theme": "介面主题",
    "editOrder": "编辑顺序",
    "autoMode": "自动模式",
    "submodel": "辅助模型",
    "timeOutinSec": "超时时间（秒）",
    "emotionPrompt": "情绪提示词",
    "singleView": "单角色模式",
    "SpacedView": "多角色模式",
    "emphasizedView": "双角色模式",
    "pluginWarn": "但安装恶意插件可能导致问题。",
    "pluginConfirm": "你真的要导入这个插件吗？只从可信的来源导入插件。",
    "pluginContainsExternalMedia": "此插件包含外部媒体。",
    "pluginContainsExternalJS": "此插件包含外部 Javascript。",
    "createGroupImg": "产生群组头像",
    "waifuWidth": "角色对话框宽度",
    "savebackup": "备份至 Google",
    "loadbackup": "从 Google 读取备份",
    "files": "文件",
    "backupConfirm": "你确定要保存备份吗？",
    "backupLoadConfirm": "你确定要读取备份吗？所有数据将被覆盖！",
    "backupLoadConfirm2": "你**真的、真的**确定要加载备份吗？这将会清除所有数据！",
    "pasteAuthCode": "请从弹出窗口复制鉴别码并贴入：",
    "others": "其他",
    "presets": "默认设置",
    "imageGeneration": "图像生成",
    "provider": "提供者",
    "key": "密钥（Key）",
    "noData": "没有数据",
    "currentImageGeneration": "当前图像生成数据",
    "promptPreprocess": "使用提示词预处理",
    "SwipeRegenerate": "使用滑动箭头重新产生消息",
    "instantRemove": "删除消息时连带删除后续消息",
    "instantRemoveConfirm": "你想只删除一条消息吗？若选择“否”，后续消息也将被删除。",
    "textColor": "文字颜色",
    "classicRisu": "经典叡苏",
    "highcontrast": "高对比度",
    "quickPreset": "可通过 Ctrl +（默认顺序编号）快速切换默认。",
    "requestretrys": "请求失败时重试",
    "utilityBot": "工具机器人",
    "ShowLog": "显示请求记录",
    "waifuWidth2": "角色显示宽度",
    "sayNothing": "无输入内容时自动填入 ’say nothing‘",
    "regexScript": "正则表达式",
    "type": "类型",
    "editInput": "修改输入",
    "editOutput": "修改输出",
    "editProcess": "修改请求数据",
    "loadLatest": "读取最新的备份",
    "loadOthers": "读取其他备份",
    "exampleMessage": "示范消息",
    "creatorNotes": "创建者备注",
    "systemPrompt": "系统提示词",
    "characterNotes": "角色备注",
    "personality": "性格",
    "scenario": "场景",
    "alternateGreetings": "备选问候语",
    "unrecommended": "不建议",
    "chatNotes": "聊天备注",
    "showUnrecommended": "显示不建议的设置",
    "streamingDisplayOptimizationMode": "流式显示优化",
    "streamingDisplayOptimizationOff": "关闭",
    "streamingDisplayOptimizationBalanced": "均衡",
    "streamingDisplayOptimizationStrong": "强",
    "altGreet": "备选初始消息",
    "scripts": "脚本",
    "settings": "设置",
    "selective": "选择性",
    "SecondaryKeys": "次要关键词",
    "useGlobalSettings": "使用全局设置",
    "recursiveScanning": "递归扫描",
    "creator": "创建者",
    "CharVersion": "角色版本",
    "Speech": "语音",
    "ToggleSuperMemory": "激活 SupaMemory",
    "SuperMemory": "SupaMemory",
    "useExperimental": "激活实验性功能",
    "showMemoryLimit": "显示记忆上限",
    "showFirstMessagePages": "显示第一条消息页面",
    "roundIcons": "圆形头像",
    "streaming": "即时串流传输",
    "chatBot": "聊天机器人",
    "otherBots": "其他机器人",
    "user": "用户",
    "additionalAssets": "额外资源",
    "editDisplay": "修改显示",
    "community": "社区",
    "textBackgrounds": "自定义文本窗口颜色",
    "textBorder": "文字边框",
    "textScreenRound": "圆角化文本窗口",
    "textScreenBorder": "文本窗口边框",
    "ttsReadOnlyQuoted": "仅朗读引号内容",
    "ttsStop": "停止语音合成",
    "askRemoval": "请求删除",
    "replaceGlobalNote": "替换全局备注",
    "charLoreBook": "角色世界书",
    "globalLoreBook": "全局世界书",
    "globalRegexScript": "全局正则表达式",
    "accessibility": "辅助功能",
    "sendWithEnter": "使用 Enter 键发送（取消检查时Shift + Enter更改为消息传送。）",
    "fixedChatTextarea": "固定聊天窗口底部",
    "clickToEdit": "点击文字进行编辑",
    "setNodePassword": "设置密码以提升安全性",
    "inputNodePassword": "输入密码。如果忘记密码，请删除服务器文档中的 save/__password.txt 并重启服务器。",
    "simple": "基本",
    "advanced": "高级",
    "askReRollAutoSuggestions": "自动滚动建议",
    "creatingSuggestions": "正在产生建议⋯",
    "orderByOrder": "按顺序对话",
    "removeFromGroup": "确定要将 {{char}} 移出群组吗？",
    "talkness": "健谈度",
    "active": "活跃",
    "loreRandomActivation": "激活概率条件",
    "activationProbability": "概率",
    "shareCloud": "分享至 RisuRealm",
    "hub": "RisuRealm",
    "tags": "标签",
    "backgroundHTML": "背景嵌入",
    "copied": "已复制",
    "useChatCopy": "激活聊天消息复制",
    "useChatSticker": "激活聊天贴图",
    "useAdditionalAssetsPreview": "使用额外资源预览",
    "autoTranslateInput": "自动输入翻译",
    "enterMessageForTranslateToEnglish": "输入消息以翻译成英文",
    "recent": "最新",
    "downloads": "下载",
    "trending": "热门",
    "imageCompression": "图片压缩",
    "notLoggedIn": "尚未登录 Risu 账号",
    "googleDriveInfo": "连接至 Google Drive 以同步数据。",
    "googleDriveConnection": "连接 Google Drive",
    "googleDriveConnected": "已连接 Google Drive",
    "SaveDataInAccount": "保存数据到账号",
    "dataSavingInAccount": "正在将数据保存到账号",
    "logout": "注销",
    "loadDataFromAccount": "从账号读取数据",
    "saveCurrentDataToAccount": "保存目前数据到账号",
    "chatAssumed": "",
    "proxyAPIKey": "代理密钥/密码",
    "proxyRequestModel": "请求模型",
    "officialWiki": "官方 Wiki",
    "officialWikiDesc": "欢迎查看叡苏官方的 Wiki。",
    "officialDiscord": "官方 Discord",
    "officialDiscordDesc": "叡苏官方的 Discord 服务器",
    "persona": "用户信息",
    "icon": "头像",
    "account": "账号",
    "remove": "删除",
    "able": "激活",
    "assetWidth": "额外资源图片最大宽度",
    "animationSpeed": "动画速度",
    "screenshot": "截图",
    "screenshotSaved": "截图已保存",
    "createBotwithAI": "使用 AI 创建机器人",
    "changeFolderName": "输入新数据夹名称（留空以取消）",
    "cancel": "取消",
    "renameFolder": "重命名数据夹",
    "changeFolderColor": "更改数据夹颜色",
    "changeFolderImage": "更改文件夹图片",
    "fullWordMatching": "完整单词匹配",
    "botSettingAtStart": "激活时显示机器人菜单",
    "triggerStart": "聊天发送时触发",
    "triggerInput": "用户输出时触发",
    "triggerOutput": "角色输出时触发",
    "triggerManual": "仅限手动触发",
    "triggerCondVar": "如果变量为",
    "triggerCondExists": "如果聊天中存在文字",
    "triggerScript": "触发器",
    "triggerMatchRegex": "与正则表达式匹配",
    "triggerMatchLoose": "宽松匹配",
    "triggerMatchStrict": "严格匹配",
    "searchDepth": "搜索深度",
    "equal": "等于",
    "notEqual": "不等于",
    "greater": "大于",
    "less": "小于",
    "greaterEqual": "大于或等于",
    "lessEqual": "小于或等于",
    "triggerEffSysPrompt": "添加系统提示词",
    "triggerEffSetVar": "修改变量",
    "triggerEffImperson": "发送聊天消息",
    "triggerEffCommand": "执行命令",
    "triggerEffRunTrigger": "执行触发器",
    "triggerEffStop": "停止发送提示词",
    "triggerEffCall": "调用触发器",
    "varableName": "变量名",
    "role": "身份",
    "location": "位置",
    "promptstart": "提示词开始",
    "promptend": "提示词结束",
    "historyend": "聊天历史结束",
    "always": "总是",
    "noEffect": "无效果",
    "invaildTriggerEffect": "此效果不适用于该触发类型。",
    "operator": "运算符",
    "TriggerSetToVar": "设置为变量",
    "TriggerAddToVar": "增加为变量",
    "TriggerSubToVar": "从变量中减去",
    "TriggerMulToVar": "将变量乘以",
    "TriggerDivToVar": "将变量除以",
    "isNull": "尚未设置",
    "ifChatIndex": "如果对话索引",
    "ifRandom": "如果随机",
    "ifValue": "如果值",
    "hideRealm": "隐藏 RisuRealm",
    "hideAllImages": "隐藏所有图片",
    "popularityLevel": "{} 人气",
    "colorScheme": "配色方案",
    "rangeStart": "范围开始",
    "rangeEnd": "范围结束",
    "untilChatEnd": "直到聊天结束",
    "usePromptTemplate": "使用提示词模板",
    "specialType": "特殊类型",
    "noSpecialType": "无特殊类型",
    "forceProxyAsOpenAI": "强制代理格式为 OpenAI",
    "promptTemplate": "提示词模板",
    "customInnerFormat": "自定义内部格式",
    "innerFormat": "内部格式",
    "HypaMemory": "HypaMemory",
    "ToggleHypaMemory": "激活 HypaMemory",
    "resetPromptTemplateConfirm": "你真的确定要重置提示词模板吗？",
    "emotionMethod": "情绪检测方式",
    "continueResponse": "继续回应",
    "showMenuChatList": "在菜单中显示聊天列表",
    "translatorLanguage": "翻译目标语言",
    "translatorType": "翻译器类型",
    "htmlTranslation": "HTML 翻译",
    "deeplKey": "DeepL API 密钥",
    "deeplFreeKey": "DeepL 免费 API 密钥",
    "deeplXUrl": "DeepLX URL",
    "deeplXToken": "DeepLX Token",
    "exportPersona": "导出用户设置",
    "importPersona": "导入用户设置",
    "export": "导出",
    "import": "导入",
    "supporterThanks": "支持者感谢",
    "supporterThanksDesc": "感谢您的支持！",
    "donatorPatreonDesc": "为保护隐私，默认不会显示在名单中。若想显示您的昵称，请前往叡苏的 Patreon 页面并点击链接按钮。",
    "useNamePrefix": "使用名称前缀",
    "textAdventureNAI": "以文字冒险形式运行",
    "appendNameNAI": "附加名称至 NAI",
    "customStopWords": "自定义停止词",
    "defaultPrompt": "默认提示词",
    "additionalText": "额外提示",
    "seed": "Seed",
    "charjs": "角色 JavaScript",
    "depthPrompt": "提示词深度",
    "largePortrait": "肖像",
    "lorePlus": "Lorebook+",
    "reverseProxyOobaMode": "Ooba 模式",
    "joinMultiUserRoom": "加入多用户聊天室",
    "exactTokens": "精确 Tokens",
    "fixedTokens": "估算 Tokens",
    "inlayViewScreen": "内嵌窗口",
    "imgGenPrompt": "图像生成提示词",
    "imgGenNegatives": "图像生成负面提示词",
    "imgGenInstructions": "系统提示词",
    "usePlainFetchWarn": "使用 NovelAI 时请关闭此选项，避免出现 CORS 错误。",
    "translationPrompt": "翻译提示词",
    "translationResponseSize": "翻译回应长度",
    "webdeeplwarn": "此功能不不建议于网页版使用，避免出现 CORS 错误。",
    "saveBackupLocal": "本地保存备份",
    "loadBackupLocal": "本机读取备份",
    "topP": "Top P",
    "genTimes": "生成次数",
    "cot": "思维链（CoT）",
    "forcePlainFetch": "强制简单抓取",
    "autoFillRequestURL": "自动填入请求 URL",
    "newOAIHandle": "新的 OpenAI 处理方式",
    "inlayImage": "内嵌图片功能",
    "nativeAutomark": "实验性本地自动标记",
    "assistantPrefill": "助理预填充",
    "postEndInnerFormat": "结尾内部格式",
    "sendChatAsSystem": "以系统身份发送消息",
    "sendName": "非群聊时发送名称",
    "utilOverride": "实用程序改写",
    "template": "模板",
    "chatAsOriginalOnSystem": "以原始身份发送",
    "exportAsDataset": "导出保存数据为数据集",
    "editTranslationDisplay": "修改翻译显示",
    "selectModel": "选择模型",
    "autoRemoveThoughtTag": "删除思维标记",
    "customChainOfThought": "自定义思维链",
    "maxThoughtTagDepth": "思维标记最大深度",
    "openRouterFallback": "使用回退",
    "openRouterMiddleOut": "使用中间输出",
    "openRouterProviderOrder": "提供商优先顺序",
    "openRouterProviderOnly": "允许的提供商",
    "openRouterProviderIgnore": "忽略的提供商",
    "openRouterSearchModel": "搜索模型...",
    "openRouterSortByName": "按名称",
    "openRouterSortByPrice": "按价格",
    "openRouterSortByProvider": "按厂商",
    "openRouterSortAsc": "升序",
    "openRouterSortDesc": "降序",
    "geminiApiKey": "Gemini API 密钥",
    "removePunctuationHypa": "移除记忆标记",
    "memoryLimitThickness": "记忆上限厚度",
    "inputCardPassword": "输入角色卡密码",
    "ccv2Desc": "V2 角色卡是广泛用于聊天机器人前端的格式。",
    "ccv3Desc": "V3 角色卡是用于聊天机器人前端的新型格式。",
    "realmDesc": "RisuRealm 是叡苏的内容分享平台，你可以将角色分享给其他用户。",
    "rccDesc": "Risu Refined 角色卡具有密码保护、完整性验证等附加功能。",
    "password": "密码",
    "license": "授权",
    "licenseDesc": "你可以设置下载授权，限制角色卡对提示词的使用。",
    "passwordDesc": "你可以为角色卡设置密码，防止未经授权的访问。",
    "largePersonaPortrait": "用户肖像",
    "module": "模块",
    "modules": "模块",
    "noModules": "尚未安装任何模块。",
    "createModule": "创建模块",
    "basicInfo": "基本数据",
    "moduleContent": "模块内容",
    "confirmRemoveModuleFeature": "确定要移除此功能吗？此操作无法还原。",
    "editModule": "编辑模块",
    "importModule": "导入模块",
    "download": "下载",
    "edit": "编辑",
    "enableGlobal": "全局激活",
    "chatModulesInfo": "可选择开启或关闭此对话的模块。",
    "sideMenuRerollButton": "侧栏菜单重新加载",
    "persistentStorage": "永久存储",
    "persistentStorageSuccess": "存储已成功永久化",
    "persistentStorageFail": "存储未能永久化。你是否拒绝了请求，或浏览器不支持？",
    "persistentStorageRecommended": "建议使用永久存储",
    "persistentStorageDesc": "你的浏览器支持永久存储，建议激活以提升性能和用户体验。",
    "enable": "激活",
    "postFile": "上传文件",
    "requestInfoInsideChat": "在聊天中显示请求数据",
    "inputTokens": "输入 Tokens",
    "outputTokens": "输出 Tokens",
    "tokenWarning": "Token 计算可能不精确，仅作参考。",
    "log": "记录",
    "popularityLevelDesc": "人气会随着下载量等增加。3.7 人气约等于 1 次下载。",
    "additionalParams": "额外参数",
    "heightMode": "高度模式",
    "useAdvancedEditor": "使用高级编辑器",
    "noWaitForTranslate": "不等待翻译",
    "updateRealm": "更新至 RisuRealm",
    "updateRealmDesc": "你正试图将角色更新至 RisuRealm。此操作将使角色更新至 RisuRealm，且无法还原。",
    "antiClaudeOverload": "防止 Claude 超载",
    "activeTabChange": "目前的标签已停用，因其他标签处于活动中。若要激活此标签，请按“确定”。",
    "maxSupaChunkSize": "最大 SupaMemory Chunk 大小",
    "addCharacter": "新增角色",
    "importFromRealm": "从 RisuRealm 选择",
    "importFromRealmDesc": "RisuRealm 提供超过 1000 位角色",
    "random": "随机",
    "metaData": "Metadata",
    "autoContinueMinTokens": "目标 Tokens（自动继续）",
    "autoContinueChat": "防止不完整回复（自动继续）",
    "removeIncompleteResponse": "移除不完整句子",
    "tokenizer": "Tokenizer",
    "chatFormating": "聊天格式",
    "useInstructPrompt": "激活命令提示词",
    "hanuraiMemory": "HanuraiMemory",
    "textAreaSize": "输入栏大小",
    "textAreaTextSize": "输入栏文字大小",
    "sideBarSize": "侧边栏大小",
    "embedding": "嵌入",
    "syntax": "语法",
    "run": "执行",
    "noMessage": "输入内容以开始聊天。",
    "combineTranslation": "合并翻译",
    "dynamicAssets": "动态资源",
    "dynamicAssetsEditDisplay": "在接口上使用动态资源",
    "longTermMemory": "长期记忆",
    "grid": "网格",
    "list": "列表",
    "trash": "垃圾桶",
    "trashDesc": "删除的角色将移至垃圾桶，可选择还原或永久删除。删除的角色将在 3 天后自动永久删除。",
    "shareExport": "分享/导出",
    "risupresetDesc": "Risupreset 是专为叡苏默认设置设计的格式。",
    "risuMDesc": "RisuM 是专为叡苏模块设计的格式。",
    "jsonDesc": "JSON 是一种人机都易于读写的格式。",
    "nickname": "昵称",
    "useRegexLorebook": "使用正则表达式",
    "customPromptTemplateToggle": "自定义开关",
    "defaultVariables": "默认变量",
    "hypaAllocatedTokens": "已分配的 Tokens",
    "hypaChunkSize": "Chunk 大小",
    "hypaV2Desc": "HypaMemory V2 是一种结合摘要数据和向量搜索的长期记忆系统。",
    "supaDesc": "SupaMemory 是一种使用摘要数据的长期记忆系统。",
    "hanuraiDesc": "HanuraiMemory 是一个使用向量搜索的记忆系统。",
    "lowLevelAccess": "低层级访问",
    "resultStoredVar": "存储结果的变量",
    "triggerEffRunLLM": "执行主控模型",
    "triggerEffectSendAI": "重新发送 AI",
    "triggerEffCheckSim": "检查相似度",
    "triggerEffShowAlert": "显示警告",
    "normal": "正常",
    "error": "错误",
    "input": "输入",
    "select": "选择",
    "options": "选项",
    "alertContent": "警告内容",
    "lowLevelAccessConfirm": "此内容使用低层级访问，可直接访问 AI 模型和你的存储数据。你确定要导入吗？",
    "triggerLowLevelOnly": "此触发仅适用于低层级访问，需在角色或模块的高级设置中激活低层级访问。",
    "truthy": "真值",
    "extractRegex": "使用正则表达式提取文字",
    "runImgGen": "执行图像生成",
    "cutChat": "分割聊天",
    "modifyChat": "修改聊天",
    "regex": "正则表达式",
    "flags": "修饰符",
    "resultFormat": "结果格式",
    "negPrompt": "负面提示词",
    "start": "开始",
    "end": "结束",
    "index": "索引",
    "search": "搜索",
    "goCharacterOnImport": "导入后跳转至角色页面",
    "format": "格式",
    "v2Warning": "警告：已停止支持 V2 角色卡，可能会缺失部分数据。",
    "applyModule": "套用模块",
    "successApplyModule": "已成功套用模块",
    "font": "字体",
    "lineHeight": "行距",
    "loadAutoServerBackup": "读取服务器自动备份",
    "notCharxWarn": "角色使用多项资源，建议导出为 CharX 格式以提升兼容性。",
    "noPlugins": "未安装插件",
    "legacyTranslation": "旧版翻译",
    "clipboardSuccess": "已复制到剪贴板",
    "translateContent": "翻译内容",
    "doNotTranslate": "不进行翻译",
    "includePersonaName": "包含用户名称",
    "hidePersonaName": "隐藏用户名称",
    "triggerSwitchWarn": "更改触发类型后，现有触发将被清除。你确定要继续吗？",
    "codeMode": "程序码",
    "blockMode": "区块",
    "helpBlock": "帮助",
    "hideChatIcon": "隐藏头像",
    "loadInternalBackup": "读取内部备份",
    "createCopy": "新建副本",
    "bindPersona": "绑定用户",
    "chatOptions": "聊天选项",
    "doYouWantToBindCurrentPersona": "是否绑定当前用户至此聊天？",
    "doYouWantToUnbindCurrentPersona": "是否解除此对话中的用户绑定？",
    "personaBindedSuccess": "用户绑定已完成",
    "personaUnbindedSuccess": "用户绑定已解除",
    "parameters": "参数",
    "sizeAndSpeed": "大小与速度",
    "useLegacyGUI": "使用旧版接口",
    "claudeCachingExperimental": "Claude 缓存",
    "openClose": "开启／关闭",
    "hideApiKeys": "隐藏 API 密钥",
    "unformatQuotes": "禁用引号格式",
    "enableDevTools": "激活开发者工具",
    "selectFile": "选择文件",
    "namespace": "命名空间",
    "moduleIntergration": "模块集成",
    "previewInfo": "此预览显示模型处理前的提示词。",
    "miscTools": "其他工具",
    "promptConvertion": "提示词转换",
    "convertionStep1": "选择与提示词相关的文件（支持 Context、Instruct 及 Sampler JSON）",
    "customCSS": "自定义 CSS",
    "betaMobileGUI": "测试版行动接口",
    "menu": "菜单",
    "connectionOpen": "已开启连接",
    "connectionOpenInfo": "多人聊天室已开启，你可以将聊天室代码分享给其他用户。其他用户可在 Playground > 加入多人聊天室 > 使用代码加入。",
    "createMultiuserRoom": "新建多人聊天室",
    "connectionHost": "你是聊天室的主持人。",
    "connectionGuest": "你是聊天室的访客。",
    "otherUserRequesting": "其他用户正在请求中，请稍后重试。",
    "jsonSchema": "JSON Schema",
    "enableJsonSchema": "启用 Schema",
    "strictJsonSchema": "严格 Schema",
    "extractJson": "提取 JSON",
    "reloadSession": "发现更新版本的存储数据，正在重新加载对话⋯",
    "fixMarkdownNewline": "修正 Markdown 换行",
    "customQuotes": "自定义引号",
    "leadingSingleQuote": "上单引号",
    "leadingDoubleQuote": "上双引号",
    "trailingSingleQuote": "下单引号",
    "trailingDoubleQuote": "下双引号",
    "translatorNote": "翻译器备注",
    "formatGroupInSingle": "单一群组格式",
    "groupInnerFormat": "非发言者内部格式",
    "groupOtherBotRole": "群组内非发言者的身份",
    "defineCustomGUI": "自定义界面",
    "chatHTML": "聊天介面 HTML",
    "logShare": "显示分享记录按钮",
    "preview": "预览",
    "recommended": "推荐",
    "newChat": "新对话",
    "predictedOutput": "预测输出",
    "systemContentReplacement": "替换系统内容",
    "systemRoleReplacement": "替换系统角色",
    "seperateParameters": "分离参数",
    "seperateParametersEnabled": "激活分离参数",
    "summarizationPrompt": "摘要提示词",
    "reSummarizationPrompt": "重新摘要提示词",
    "translatorPrompt": "翻译提示词",
    "translateBeforeHTMLFormatting": "於 HTML 格式化前翻译",
    "retranslate": "重新翻译",
    "editTranslation": "编辑翻译",
    "editTranslationSave": "保存翻译",
    "exportTranslationCache": "导出翻译缓存",
    "exportTranslationCacheSuccess": "翻译缓存导出成功。",
    "importTranslationCache": "导入翻译缓存",
    "importTranslationCacheConfirm": "这将把条目合并到翻译缓存中。已有的键将被覆盖。是否继续？",
    "importTranslationCacheSuccess": "已导入 {0} 条翻译缓存。",
    importTranslationCacheFailed: "已导入{0}个条目，但{1}个条目保存失败。存储空间可能已满。",
    "exportTranslationCacheEmpty": "翻译缓存为空。",
    clearTranslationCache: "清除翻译缓存",
    clearTranslationCacheSuccess: "翻译缓存已清除。",
    clearTranslationCacheConfirm: "这将删除所有翻译缓存条目，此操作不可撤销。是否继续？",
    "loading": "加载中",
    "autoTranslateCachedOnly": "仅自动翻译缓存的消息",
    "notification": "通知",
    "permissionDenied": "您的浏览器或操作系统拒绝了权限",
    "customFlags": "自定义标志",
    "enableCustomFlags": "启用自定义标志",
    "googleCloudTokenization": "Google Cloud Tokenization",
    "presetChain": "预设链",
    "legacyMediaFindings": "旧版媒体查找",
    "staticsDisclaimer": "统计数据基于 2024 年 7 月以后的数据。数据可能不准确。",
    "subtitles": "字幕",
    "subtitlesWarning1": "您必须使用支持音频/视频输入的模型才能使用此功能。",
    "subtitlesWarning2": "您必须使用支持流式传输功能的模型才能使用此功能。",
    "reset": "重置",
    "assetMaxDifference": "资源最大差异",
    "sourceLanguage": "源语言",
    "destinationLanguage": "目标语言",
    "noWebGPU": "您的浏览器或操作系统不支持 WebGPU。这将显着降低性能。",
    "menuSideBar": "菜单侧边栏",
    "home": "主页",
    "showSavingIcon": "显示保存图标",
    "pluginVersionWarn": "这是插件的 {{plugin_version}} 版本。它与此版本的 Risuai 不兼容。请将插件更新到 {{required_version}} 版本。",
    "imageTranslation": "图片翻译",
    "banCharacterset": "字符集自动重新生成",
    "realmDirectOpen": "在 RisuRealm 中直接打开角色",
    "showPromptComparison": "显示提示词比较",
    "inlayErrorResponse": "嵌入错误响应",
    "triggerOn": "触发于",
    "noConfig": "无配置",
    "varName": "变量名",
    "var": "变量",
    "condition": "条件",
    "trigger": "触发器",
    "outputVar": "输出变量",
    "source": "来源",
    "cmd": "命令",
    "sysStart": "系统开始",
    "sysHistoryEnd": "系统历史结束",
    "sysPromptEnd": "系统提示结束",
    "target": "目标",
    "addElse": "添加否则",
    "min": "最小值",
    "max": "最大值",
    "delimiter": "分隔符",
    "deleteCount": "删除数量",
    "triggerEffRunAxLLM": "运行辅助模型",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 是一个使用总结和向量搜索的长期记忆系统。",
        "supaMemoryPromptPlaceHolder": "留空以使用默认值",
        "maxMemoryTokensRatioLabel": "最大记忆令牌比率（估计）",
        "maxMemoryTokensRatioError": "无法计算最大记忆令牌比率",
        "memoryTokensRatioLabel": "记忆令牌比率",
        "extraSummarizationRatioLabel": "额外总结比率",
        "maxChatsPerSummaryLabel": "每个总结的最大消息数",
        "recentMemoryRatioLabel": "最近记忆比率",
        "similarMemoryRatioLabel": "相似记忆比率",
        "randomMemoryRatioLabel": "随机记忆比率",
        "enableSimilarityCorrectionLabel": "启用相似度校正",
        "preserveOrphanedMemoryLabel": "保留孤立记忆",
        "applyRegexScriptWhenRerollingLabel": "重新生成时应用正则脚本",
        "doNotSummarizeUserMessageLabel": "不要总结用户消息"
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3",
        "resetConfirmMessage": "此操作无法撤销。您要重置 HypaV3 数据吗？",
        "resetConfirmSecondMessage": "此操作不可逆。您确实要重置 HypaV3 数据吗？",
        "convertLabel": "尚无总结，但您可以将 HypaV2 数据转换为 V3。",
        "convertButton": "转换为 V3",
        "convertSuccessMessage": "成功将 HypaV2 数据转换为 V3",
        "convertErrorMessage": "将 HypaV2 数据转换为 V3 失败：{0}",
        "noSummariesLabel": "尚无总结",
        "searchPlaceholder": "输入 #N、ID 或搜索关键词",
        "summaryNumberLabel": "总结 #{0}",
        "deleteThisConfirmMessage": "删除此摘要？",
        "deleteAfterConfirmMessage": "删除此后的所有总结？",
        "deleteAfterConfirmSecondMessage": "此操作无法撤销。您确定吗？",
        "translationLabel": "翻译",
        "rerolledSummaryLabel": "重新生成的总结",
        "rerolledTranslationLabel": "重新生成的总结翻译",
        "connectedMessageCountLabel": "关联消息 ({0})",
        "connectedFirstMessageLabel": "第一条消息",
        "connectedMessageRoleLabel": "{0} 的消息",
        "connectedMessageNotFoundLabel": "未找到消息",
        "connectedMessageLoadingError": "加载关联消息时出错：{0}",
        "connectedMessageTranslationLabel": "翻译",
        "nextSummarizationFirstMessageLabel": "第一条消息",
        "nextSummarizationNoMessageIdLabel": "无消息 ID",
        "nextSummarizationLabel": "HypaV3 将总结 [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "警告：未找到消息",
        "nextSummarizationLoadingError": "加载下一个总结目标时出错：{0}",
        "summarizationConditionLabel": "提示：当输入标记超过最大上下文大小时，HypaV3 将开始进行摘要处理。",
        "emptySelectedFirstMessageLabel": "警告：所选的第一条消息为空",
        "unclassified": "未分类",
        "reSummarize": "重新总结",
        "reSummarizing": "重新总结中...",
        "reSummarizeResult": "重新总结结果",
        "retry": "重试",
        "translate": "翻译",
        "tag": "标签",
        "tagManager": "标签管理",
        "tagManagerTitle": "标签管理 - 总结 #{0}",
        "newTagName": "新标签名称",
        "noTagsYet": "暂无标签。",
        "addNewTagHint": "在上方添加新标签。",
        "categoryManager": "分类",
        "allCategories": "全部",
        "categoryName": "分类名称",
        "noCategoriesYet": "暂无分类。",
        "addNewCategoryHint": "点击上方的 + 按钮添加。"
    },
    "bulkEnabling": "批量启用世界书",
    "showTranslationLoading": "显示翻译加载中",
    "showDeprecatedTriggerV1": "显示已弃用的触发器 V1",
    "showDeprecatedTriggerV2": "显示已弃用的触发器 V2",
    "triggerV1Warning": "触发器 V1 已弃用。将来可能会被删除。",
    "copy": "复制",
    "paste": "粘贴",
    "depth": "深度",
    "returnCSSError": "返回 CSS 错误",
    "alwaysActiveInChat": "始终激活（当前聊天）",
    "childLoreDesc": "这是角色世界书的副本，保持“始终激活”，直到在原始版本中删除或手动停用。",
    "thinkingTokens": "思考 Tokens",
    "antiServerOverload": "反服务器过载",
    "localActivationInGlobalLorebook": "全局世界书中的本地激活",
    "cachePoint": "缓存点",
    "all": "全部",
    "showFolderNameInIcon": "在图标中显示文件夹名称",
    "claudeCachingRetrival": "Claude 缓存检索",
    "claudeCachingRetrivalDesc": "通过每 4 分钟请求一次来延长 Claude 缓存的缓存时间。这可以降低缓存未命中率，但如果不正确使用，可能会增加成本。",
    "automaticCachePoint": "自动缓存点",
    "experimentalChatCompression": "实验性聊天数据处理",
    "loadingChatData": "加载聊天数据",
    "outputImageModal": "输出图像模态框",
    "playMessageOnTranslateEnd": "翻译完成后播放音频",
    "auxModelUnderModelSettings": "在模型设置中显示辅助模型分离",
    "seperateModelsForAxModels": "为辅助模型分离模型",
    "axModelsDef": "辅助模型定义",
    "doNotChangeSeperateModels": "预设更改时不要更改分离模型",
    "tools": "工具",
    "action": "动作",
    "hotkey": "快捷键",
    "hotkeyDesc": {
        "reroll": "重新生成",
        "unreroll": "撤销重新生成",
        "translate": "翻译",
        "remove": "移除",
        "edit": "编辑",
        "copy": "复制",
        "send": "发送",
        "settings": "设置",
        "home": "主页",
        "presets": "快速预设选择",
        "persona": "快速用户选择",
        "modelSelect": "快速模型选择",
        "toggleCSS": "切换 CSS",
        "prevChar": "上一个角色",
        "nextChar": "下一个角色",
        "quickMenu": "快速菜单",
        "quickSettings": "快速设置",
        "toggleVoice": "切换语音",
        "toggleLog": "切换日志",
        "previewRequest": "预览请求",
        "import": "导入",
        "export": "导出",
        "webcam": "切换摄像头",
        "focusInput": "聚焦输入框",
        "scrollToActiveChar": "滚动至当前角色"
    },
    "screenTooSmall": "屏幕太小，无法显示界面。",
    "advancedModelSettings": "高级模型设置",
    "fallbackModel": "回退模型",
    "fallbackWhenBlankResponse": "空白响应时回退",
    "doNotChangeFallbackModels": "预设更改时不要更改回退模型",
    "customModels": "自定义模型",
    "igpPrompt": "IGP 提示词",
    "useTokenizerCaching": "Tokenizer 缓存",
    "hypaMemoryV2Modal": "Hypa V2 模态框",
    "hypaMemoryV3Modal": "Hypa V3 模态框",
    "showMenuHypaMemoryModal": "显示菜单 Hypa 模态框",
    "promptInfoInsideChat": "添加提示信息到聊天",
    "promptTextInfoInsideChat": "添加提示文本到聊天",
    "promptInfoEmptyMessage": "此消息没有可用的提示信息。",
    "promptInfoEmptyToggle": "当前没有激活的自定义开关。",
    "promptInfoEmptyText": "没有保存提示文本。",
    "escapeOutput": "转义输出",
    "openAIFlexProcessing": "OpenAI Flex 处理",
    "claudeBatching": "Claude 批处理",
    "claude1HourCaching": "Claude 1 小时缓存",
    "folderNameInput": "请输入新文件夹名称",
    "folderRemoveLengthError": "要删除文件夹，它必须不包含任何条目。",
    "personaNote": "用户备注",
    "mcpAccessPrompt": "{{tool}} 正在尝试 \"{{action}}\"。您要允许吗？",
    "rememberToolUsage": "记住工具使用情况",
    "simplifiedToolUse": "简化工具使用",
    "toolCalled": "工具 '{{tool}}' 被调用",
    "static": "静态",
    "dynamic": "动态",
    "assetStyle": "资源样式",
    "insertAssetPrompt": "插入资源提示词",
    "requestLocation": "请求位置",
    "newImageHandlingBeta": "新图像处理 (Beta)",
    "settingsExported": "错误报告的设置已导出并复制到剪贴板。",
    "bookmarks": "书签",
    "noBookmarks": "无书签",
    "bookmarkAskNameOrDefault": "输入书签名称。如果未输入，将自动分配。",
    "bookmarkAskNameOrCancel": "输入书签名称。如果未输入，重命名将被取消。",
    "collapseAll": "全部折叠",
    "expandAll": "全部展开",
    "hideErrorDetails": "隐藏错误详情",
    "showErrorDetails": "显示错误详情",
    "dynamicOutput": "动态输出",
    "autoAdjustSchema": "自动调整 Schema",
    "dynamicMessages": "动态消息",
    "dynamicMemory": "动态记忆",
    "dynamicResponseTiming": "动态响应时间",
    "showTypingEffect": "显示打字效果",
    "dynamicRequest": "动态请求",
    "dynamicOutputPrompt": "动态输出提示词",
    "settingsCloseButtonSize": "设置关闭按钮大小",
    "translating": "翻译中...",
    "stackTraceTranslationFailed": "堆栈跟踪翻译失败。下面显示原始混淆后的堆栈跟踪。",
    "translate": "翻译代码地址",
    "apply": "应用",
    "add": "追加",
    "nightlyWarning": "## Nightly Builds\n\n您正在连接到软件的每夜构建版本。此版本用于测试，很可能包含错误。**在此版本中，即使您遇到问题，我们也不支持直接解决它们。**",
    "loginSionyw": "使用 Sionyw 账号登录",
    "pluginRiskDetectedAlert": "Risuai 检测到可能有害的代码，这可能会窃取您的 API 密钥或个人数据。我们建议您不要安装此插件。",
    "doNotInstall": "不要安装",
    "continueAnyway": "仍然继续",
    "pluginNoRiskButAlert": "Risuai 没有检测到有害代码，但请注意，从不受信任的来源安装插件可能会带来安全风险。",
    "pluginRisksInuserFriendly": {
        "eval": "从字符串评估代码",
        "globalAccess": "访问全局变量",
        "thisOutsideClass": "在类上下文之外使用 'this'",
        "errorInVerification": "验证过程中出错",
        "storageAccess": "访问存储"
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "该插件尝试从字符串执行代码，字符串可能会被混淆以隐藏恶意代码。",
        "globalAccess": "该插件尝试访问全局变量，这可能导致意外的副作用或安全漏洞。",
        "thisOutsideClass": "该插件在类上下文之外使用 'this' 关键字，这可能导致意外行为或安全问题。",
        "errorInVerification": "插件验证过程中出现错误，表明其功能可能存在问题。",
        "storageAccess": "该插件尝试访问存储，这可能导致数据泄露或未经授权的数据操作。"
    },
    "generatedByAIDisclaimer": "此内容由 AI 生成，可能包含不准确信息或偏见。",
    "aiGenerationWarning": "内容将由 AI 生成，可能包含不准确信息或偏见。",
    "bookmark": "书签",
    "loadMore": "加载更多",
    "pluginUpdateFoundInstallIt": "发现插件更新。是否安装更新？",
    "goToChat": "前往聊天",
    "branchedText": "此对话分支自 {}。",
    "noRequestLogs": "暂无请求日志。",
    "duplicatePluginFoundUpdateIt": "发现重复插件。是否更新现有插件？",
    "branch": "分支",
    "newMessageButtonStyle": "新消息按钮样式",
    "newMessageButtonFloatingCircle": "悬浮圆 (右下角)",
    "newMessageButtonBottomCenter": "底部居中 (默认)",
    "newMessage": "新消息",
    "disableMessage": "禁用消息",
    "newMessageButtonBottomLeft": "左下角",
    "newMessageButtonBottomRight": "右下角",
    "alwaysScrollToNewMessage": "始终滚动到新消息（忽略滚动位置）",
    "autoScrollToNewMessage": "自动滚动至新消息",
    "disableAbove": "为 AI 剪裁的消息",
    "pluginDevelopMode": "插件开发模式",
    "newMessageButtonTopBar": "顶栏",
    "newMessageButtonRightCenter": "右中",
    "mainDomAccessConsent": "插件 {} 正在请求访问主文档，这可能会泄露敏感信息。是否允许？",
    "getFullDatabaseConsent": "插件 {} 正在请求访问完整数据库，这可能会泄露敏感信息。是否允许？",
    "fetchLogConsent": "插件 {} 正在请求获取日志，这可能会泄露敏感信息。是否允许？",
    "enableScrollToActiveChar": "启用滚动至当前角色",
    "trimStartNewChat": "修剪“开始新对话”消息",
    "hamburgerButtonBottom": "将菜单按钮移至侧边栏底部",
    "nanoGPTLoadingAccountInfo": "正在加载账户信息…",
    "nanoGPTCreditBalance": "余额:",
    "nanoGPTSubscription": "订阅",
    "nanoGPTGraceUntil": (date: string) => `至 ${date}`,
    "nanoGPTNoActiveSubscription": "无活跃订阅。",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `到期后取消 (${date})`,
    "nanoGPTWeeklyTokens": (pct: string) => `每周包含输入 Token — 已使用 ${pct}`,
    "nanoGPTDailyTokens": (pct: string) => `每日包含输入 Token — 已使用 ${pct}`,
    "nanoGPTDailyImages": (pct: string) => `每日包含图片 — 已使用 ${pct}`,
    "nanoGPTResets": (date: string) => `重置于 ${date}`,
    "nanoGPTUsed": (n: string) => `已使用 ${n}`,
    "nanoGPTRemaining": (n: string) => `剩余 ${n}`,
    "nanoGPTRenews": (date: string) => `续费日期: ${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "无法加载账户信息。",
    "nanoGPTWeeklyTokensLabel": "每周包含输入令牌",
    "nanoGPTDailyTokensLabel": "每日包含输入令牌",
    "nanoGPTDailyImagesLabel": "每日包含图片",
    "nanoGPTUsedLabel": "已使用",
    "nanoGPTRemainingLabel": "剩余",
    "nanoGPTResetsLabel": "重置",
    "nanoGPTRenewsLabel": "续订:",
    "nanoGPTProvider": "服务商",
    "nanoGPTProviderPayAsYouGoOnly": "(仅在按量付费模式下可用)",
    "nanoGPTProviderAuto": "自动",
    "nanoGPTProviderFree": "免费",
    "nanoGPTProviderInput": "输入",
    "nanoGPTProviderOutput": "输出",
    "nanoGPTProviderQuantization": "量化",
    "nanoGPTProviderUndisclosed": "未公开",
    "nanoGPTProviderCache": "缓存",
    "nanoGPTProviderCacheSupported": "支持",
    "nanoGPTProviderCacheNotSupported": "不支持",
    "nanoGPTProviderCacheRead": "缓存读取",
    "nanoGPTUseSubscriptionEndpoint": "使用订阅端点和模型",
    "modelGridCouldNotLoad": "无法加载模型列表。请检查您的 API 密钥。",
    "modelGridNoModelsMatch": (q: string) => `没有与"${q}"匹配的模型`,
    "modelGridContext": (n: string) => `上下文: ${n}`,

    nanoGPTSelectFromList: "从列表中选择",
    nanoGPTManualInput: "手动输入",
    nanoGPTManualModelSelect: "手动模式选择",
} satisfies DeepPartial<typeof import('./en').languageEnglish>;
